import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import DifferentialsSection from '../components/DifferentialsSection';
import SectorsSection from '../components/SectorsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <main>
      <HeroSection />
      <ServicesSection />
      <DifferentialsSection />
      <SectorsSection />
      <FAQSection />
      <CTASection />
    </main>
  );
};

export default Home;
